export const CHART_COLORS = {
  routed: 'var(--theme-primary)',
  original: '#3b82f6',
  eval_routed: '#22c55e',
  cache_hit: '#34d399',
  cached: '#34d399',
  passthrough: '#94a3b8',
  savings: '#a78bfa',
  cost: '#f472b6',
  eval: '#fbbf24',
  accent: '#6366f1',
  overhead: '#818cf8',
  generation: '#fb923c',
};

export const SERIES_COLORS = [
  CHART_COLORS.routed,
  CHART_COLORS.generation,
  CHART_COLORS.cache_hit,
  CHART_COLORS.savings,
  CHART_COLORS.cost,
  CHART_COLORS.eval,
  CHART_COLORS.passthrough,
  CHART_COLORS.accent,
];

// Negative left margins clip y-axis tick labels inside ResponsiveContainer.
export const CHART_MARGIN = { top: 4, right: 4, left: 4, bottom: 0 };

export const Y_AXIS_WIDTH = {
  count: 36,
  pct: 40,
  usd: 44,
  ms: 48,
};

export function formatUsd(value) {
  if (value == null) return '—';
  const n = Number(value);
  if (n >= 100) return `$${n.toFixed(2)}`;
  if (n >= 1) return `$${n.toFixed(2)}`;
  if (n >= 0.01) return `$${n.toFixed(4)}`;
  return `$${n.toFixed(6)}`;
}

export function formatUsdShort(value) {
  const n = Number(value || 0);
  if (n >= 100) return `$${n.toFixed(0)}`;
  if (n >= 1) return `$${n.toFixed(2)}`;
  if (n >= 0.01) return `$${n.toFixed(2)}`;
  return `$${n.toFixed(4)}`;
}

export function formatUsdAxis(value) {
  if (value >= 1) return `$${Number(value).toFixed(2)}`;
  if (value >= 0.01) return `$${Number(value).toFixed(2)}`;
  return `$${Number(value).toFixed(3)}`;
}

export function formatPct(value) {
  if (value == null) return '—';
  return `${Number(value).toFixed(1)}%`;
}

export function formatMs(value) {
  if (value == null) return '—';
  const ms = Math.round(Number(value));
  if (ms < 1000) return `${ms}ms`;
  const seconds = ms / 1000;
  if (Number.isInteger(seconds)) return `${seconds}s`;
  return `${seconds.toFixed(1)}s`;
}

export function formatPeriodLabel(period, segment) {
  const date = new Date(period);
  if (Number.isNaN(date.getTime())) return String(period).slice(0, 10);
  if (segment === 'minute') {
    return date.toLocaleString(undefined, { hour: 'numeric', minute: '2-digit' });
  }
  if (segment === 'hour') {
    return date.toLocaleString(undefined, { month: 'numeric', day: 'numeric', hour: 'numeric' });
  }
  if (segment === 'month') {
    return date.toLocaleString(undefined, { month: 'short', year: '2-digit' });
  }
  return date.toLocaleString(undefined, { month: 'numeric', day: 'numeric' });
}

export function formatDayLabel(day) {
  const date = new Date(day);
  if (Number.isNaN(date.getTime())) return String(day).slice(5, 10);
  return date.toLocaleString(undefined, { month: 'short', day: 'numeric' });
}

export function formatCostComparison(original, actual) {
  const orig = Number(original || 0);
  const act = Number(actual || 0);
  if (!orig && !act) return '$0.00 → $0.00';
  return `${formatUsdShort(orig)} → ${formatUsdShort(act)}`;
}
